import { UI } from '../nextpage';

export class Tabbed {
    constructor(private NP: UI) {
        // Tabbed
        this.NP.registerEvent("tabClick", (ev: Event) => {
            let tab = ev.target as HTMLElement;
            // Adding this to prevent clicking on span
            if (tab.tagName == "SPAN") {
                tab = tab.parentElement as HTMLLIElement;
            }
            const tabList = tab.parentElement as HTMLUListElement;
            const tabContent = tabList.parentElement.querySelectorAll('.tab-content');

            if (tab.classList.contains("aria-selected")) {
                if (!this.NP.properties.isMobile) {
                    return;
                }
                ev.stopImmediatePropagation();
                tabList.classList.toggle("toggled");
                if (tabList.classList.contains("toggled")) {
                    let listHeight = 0;
                    [].forEach.call(tabList.children, (t: HTMLLIElement) => {
                        listHeight = listHeight + t.clientHeight;
                    });
                    tabList.style.height = listHeight + "px";
                } else {
                    tabList.style.height = tab.clientHeight + "px";
                }
                return;
            }
            if (this.NP.properties.isMobile) {
                ev.stopImmediatePropagation();
                const selectedHeight = tab.clientHeight;
                tabList.style.height = selectedHeight + "px";
                tabList.parentElement.style.paddingTop = (selectedHeight + 2) + "px";
            } else {
                tabList.style.height = "auto";
                tabList.parentElement.style.paddingTop = "0px";
            }
            
            [].forEach.call(tabList.children, (t: HTMLLIElement) => {
                this.NP.toggleAriaState(t, "selected", (tab === t));
            });
            tabList.classList.toggle("toggled", false);
            const tabIndex = [].indexOf.call(tabList.children, tab);
            tabContent.forEach((tc, i) => {
                this.NP.toggleAriaState(tc, "hidden", i !== tabIndex);
            });
        });

        this.NP.components.tabbed = (selector: string | Element | NodeListOf<Element> | Array<Element>): void => {
            const tabbedComponents = this.NP.getComponentSelector(selector);
            tabbedComponents.forEach((tabbed: HTMLDivElement) => {
                const tabList = tabbed.querySelector("ul.tabs") as HTMLUListElement;
                if (tabList === null) {
                    return;
                }
                const tabs = tabList.children;
                const tabContent = tabbed.querySelectorAll(".tab-content");
                if (tabs.length === 0 || tabContent.length === 0) {
                    return;
                }
                
                let selectedTab = tabbed.querySelector('ul.tabs > li[aria-selected="true"], ul.tabs > li.aria-selected');
                let selectedContent = tabbed.querySelector('.tab-content:not([aria-hidden="true"]), .tab-content:not(.aria-hidden)');
                const isVertical = tabbed.classList.contains("vertical");
            
                // If there is no selected tab or content the first tab & content are selected.
                // Otherwise if a selected tab is found it is used and then selected content.
                if (selectedTab === null && selectedContent === null) {
                    selectedTab = tabs[0];
                    selectedContent = tabContent[0];
                } else if (selectedTab !== null) {
                    selectedContent = tabContent[Array.prototype.indexOf.call(tabs, selectedTab)];
                } else {
                    selectedTab = tabs[Array.prototype.indexOf.call(tabContent, selectedContent)];
                }
    
                [].forEach.call(tabs, (tab: HTMLLIElement) => {
                    this.NP.toggleAriaState(tab, "selected", tab === selectedTab);
                });
                tabContent.forEach((tc: HTMLElement) => {
                    this.NP.toggleAriaState(tc, "hidden", tc !== selectedContent);
                });
                
                // If this is a mobile layout we need to pad the top of the DIV with the height of the tabs list.
                if (this.NP.properties.isMobile) {
                    const selectedHeight = selectedTab.clientHeight;
                    tabbed.style.paddingTop = selectedHeight + "px";
                    tabList.style.height = selectedHeight + "px";
                }
                [].forEach.call(tabs, (tab: HTMLLIElement) => {
                    // If these are vertical tabs wrap each tab with a <span> for styling purposes.
                    if (isVertical) {
                        const vertSpan = document.createElement('span');
                        tab.childNodes.forEach((cn: HTMLElement) => {
                            vertSpan.append(cn);
                        });
                        tab.append(vertSpan);
                    }
                    
                    // When clicked change to the correct tab content and set the height of the tab list accordingly.
                    tab.addEventListener("click", (ev: Event) => this.NP.events.tabClick(ev));
                });
            });
            
            // If any toggle elements are found add a resize function for tabbed elements.
            if (tabbedComponents.length > 0 && this.NP.properties.resizeKeys.length > 0 && this.NP.properties.resizeKeys.includes('tabbed')) {
                
                document.body.addEventListener("click", () => {
                    if (!this.NP.properties.isMobile) {
                        return;
                    }
                    document.querySelectorAll("div.tabbed > ul.tabs.toggled").forEach((tabToggle) => {
                        let selectedToggle = [].filter.call(tabToggle.children, (tt: HTMLElement) => { return tt.classList.contains("aria-selected"); });
                        selectedToggle = selectedToggle.length > 0 ? selectedToggle[0] : null;
                        if (selectedToggle === null) {
                            return;
                        }
    
                        const selectedHeight = tabToggle.clientHeight;
                        selectedToggle.classList.toggle("toggled", false);
                        selectedToggle.style.height = selectedHeight + "px";
                        selectedToggle.parentElement.style.paddingTop = (selectedHeight + 2) + "px";
                    });
                });
    
                this.NP.registerResizeFunction("tabbed", () => {
                    const tabToggles = document.querySelectorAll("div.tabbed > ul.tabs");
                    if (!this.NP.properties.isMobile) {
                        tabToggles.forEach((tt: HTMLLIElement) => {
                            tt.classList.toggle("toggled", false);
                            tt.style.height = "auto";
                            tt.parentElement.style.paddingTop = "0px";
                        });
                        return;
                    }
                    tabToggles.forEach((tt: HTMLLIElement) => {
                        let selectedToggle = [].filter.call(tt.children, (ttc: HTMLElement) => { return ttc.classList.contains("aria-selected"); });
                        selectedToggle = selectedToggle.length > 0 ? selectedToggle[0] : null;
                        if (selectedToggle === null) {
                            return;
                        }
                        const selectedHeight = selectedToggle.clientHeight;
                        tt.classList.toggle("toggled", false);
                        tt.style.height = selectedHeight + "px";
                        tt.parentElement.style.paddingTop = (selectedHeight + 2) + "px";
                    });
                });
            }
        }
    };
}